import { Link } from "react-router-dom";
import { PageHero } from "../components/PageShell";
import { Figure } from "../components/Figure";
import { GALLERY_ALBUMS, GALLERY_TOTAL, albumCover, type GalleryAlbum } from "../lib/gallery";
import { ROUTES } from "../lib/routes";

/**
 * The gallery landing: an albums page rather than one endless wall. Campus
 * leads at full width, then the NAIN incubation centre, then a card per
 * department — 700-odd photographs stay navigable, and each album opens its
 * own grid at /gallery/<id>.
 */
function AlbumCard({ album, wide = false }: { album: GalleryAlbum; wide?: boolean }) {
  return (
    <Link to={`${ROUTES.gallery}/${album.id}`} className={"gal-card reveal" + (wide ? " gal-card--wide" : "")}>
      <Figure
        media={albumCover(album)}
        fallbackLabel={album.title.toUpperCase()}
        aspect={wide ? "21/9" : "3/2"}
        sizes={wide ? "(max-width: 900px) 100vw, 1100px" : "(max-width: 640px) 100vw, (max-width: 1000px) 48vw, 25vw"}
      />
      <div className="gal-card-body">
        <h3>{album.title}</h3>
        <span className="gal-count">
          {album.photos.length} photo{album.photos.length > 1 ? "s" : ""}
        </span>
        <span className="gal-arr" aria-hidden="true">→</span>
      </div>
    </Link>
  );
}

export default function Gallery() {
  const campus = GALLERY_ALBUMS.filter((a) => a.group === "campus");
  const innovation = GALLERY_ALBUMS.filter((a) => a.group === "innovation");
  const departments = GALLERY_ALBUMS.filter((a) => a.group === "department");

  return (
    <>
      <PageHero
        variant="hero-editorial"
        eyebrow="Student Life · Gallery"
        title="The campus, photographed."
        lead={`${GALLERY_TOTAL} photographs from the institute's own record — the campus and its buildings, the incubation centre, and every department's events and laboratories.`}
        crumbs={[{ label: "Gallery" }]}
        image={null}
      />

      <section className="section">
        <div className="container">
          {campus.map((a) => (
            <AlbumCard key={a.id} album={a} wide />
          ))}
          <div className="gal-grid" style={{ marginTop: 24 }}>
            {innovation.map((a) => (
              <AlbumCard key={a.id} album={a} />
            ))}
          </div>
        </div>
      </section>

      <section className="section section--flush">
        <div className="container">
          <div className="section-head">
            <div>
              <div className="kicker">By department</div>
              <h2>Department albums</h2>
            </div>
          </div>
          <div className="gal-grid">
            {departments.map((a) => (
              <AlbumCard key={a.id} album={a} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
